/**
 * User-scoped supplier API helpers.
 * @see Companies-service/docs/FRONTEND_USER_SCOPED_SUPPLIER_UPDATE_GUIDE.md
 */
import { createApiResponse } from '../models';
import { getStoredUserId } from './authSession';

/** Resolve Firebase uid for supplier create/update/read. */
export function resolveSupplierUserId(userId) {
  return userId ?? getStoredUserId() ?? null;
}

/** Query params for GET/PUT/POST /companies|/suppliers with user isolation. */
export function buildUserScopedQuery(userId) {
  const uid = resolveSupplierUserId(userId);
  return uid ? { userId: uid } : {};
}

/** Attach user_id to write payloads (body alternative to ?userId=). */
export function withUserScopedBody(payload, userId) {
  const uid = resolveSupplierUserId(userId);
  if (!uid) return payload ?? {};
  return { ...(payload ?? {}), user_id: uid };
}

/**
 * Build PUT body from form patch. Backend validation requires `ticker` in the JSON body
 * as well as in the URL path.
 */
export function toSupplierUpdatePatch(payload, pathTicker) {
  const base = payload && typeof payload === 'object' ? { ...payload } : {};
  const canonical = String(base.ticker || pathTicker || '').trim();
  if (canonical) {
    base.ticker = canonical;
  }
  return base;
}

export function mapSupplierApiError(error, fallbackMessage) {
  const data = error?.response?.data;
  return createApiResponse({
    success: false,
    message: data?.message || error?.message || fallbackMessage,
    errorCode: data?.error_code || data?.errorCode || null,
  });
}

export function isCatalogForbiddenError(response) {
  const code = response?.errorCode || response?.error_code;
  if (code === 'FORBIDDEN') return true;
  const msg = String(response?.message || '').toLowerCase();
  return msg.includes('shared catalog') || msg.includes('catalog entry');
}
